import(/* webpackMode: "eager", webpackExports: ["LanguageSuggestion"] */ "/vercel/path0/components/landing/LanguageSuggestion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/vercel/path0/components/landing/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSmartInput"] */ "/vercel/path0/components/onboarding/HeroSmartInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@8.0.6_@opentelemetry+api@1.9.0_@playwright+test@1.58.0_react-dom@19.2.3_react@19.2.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@8.0.6_@opentelemetry+api@1.9.0_@playwright+test@1.58.0_react-dom@19.2.3_react@19.2.3/node_modules/next/dist/client/image-component.js");
